// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3nPne","title":"Header_title__rmsxK","left":"Header_left__pIapO","clinicName":"Header_clinicName__2UPpd"};